import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import "../../assets/css/auth.css";
import "../../assets/css/common.css";
import { Typography, Box, CircularProgress } from "@material-ui/core";

function IntegrateWithWeb() {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const decodeParam = (key) => {
      const rawValue = params.get(key);
      return rawValue ? decodeURIComponent(rawValue) : "";
    };
    const email = decodeParam("email");
    const reportId = decodeParam("reportId");

    const checkAuthAndRedirect = async () => {
      try {
        // Cognito 세션 확인
        const session = await Auth.currentSession();
        if (session && session.isValid()) {
          // 로그인 되어있으면 localStorage에 정보 저장 후 /radon으로 이동
          localStorage.setItem("accessSource", "web");
          if (email) {
            localStorage.setItem("0xaccountId", email);
          }
          history.replace("/reports/ltreport", { email, reportId });
        }
      } catch (error) {
        // 로그인 안 되어있으면 redirect 정보 저장 후 로그인 페이지로 이동
        const redirectInfo = {
          pathname: "/reports/ltreport",
          state: { email, reportId },
        };
        localStorage.setItem(
          "redirectAfterLogin",
          JSON.stringify(redirectInfo)
        );
        history.replace("/auth/sign-in");
      }
    };

    checkAuthAndRedirect();
  }, []);

  return loading ? (
    <>
      <Box display="flex" flexDirection={"column"}>
        <div className="progress">
          <CircularProgress />
        </div>
        <div className="s20"></div>
        <Typography variant={"body1"}>Loading ..</Typography>
      </Box>
    </>
  ) : (
    <></>
  );
}

export default IntegrateWithWeb;
